import React from "react";
import folderIllustration from "../static/assets/Empty-folder.svg";
import Button from "../ui/components/Button";

const EmptyState = ({
  image = folderIllustration,
  imageAlt = "",
  title,
  description,
  buttonText,
  onButtonClick,
  buttonIcon = "fa-plus",
  secondaryButtonText,
  onSecondaryButtonClick,
  className = "",
}) => {
  const showButton = Boolean(buttonText && onButtonClick);
  const showSecondaryButton = Boolean(
    secondaryButtonText && onSecondaryButtonClick,
  );
  const showActions = showButton || showSecondaryButton;

  return (
    <div className={["empty-state", className].filter(Boolean).join(" ")}>
      <div className="empty-state__content">
        {image ? (
          <div className="empty-state__image-wrap">
            <img alt={imageAlt} src={image} className="empty-state__image" />
          </div>
        ) : null}
        <div className="empty-state__text">
          {title ? <p className="empty-state__title">{title}</p> : null}
          {description ? (
            <p className="empty-state__subtitle">{description}</p>
          ) : null}
        </div>
        {showActions ? (
          <div className="empty-state__actions">
            {showSecondaryButton ? (
              <Button
                variant="secondary"
                className="empty-state__button"
                onClick={onSecondaryButtonClick}
              >
                <span>{secondaryButtonText}</span>
              </Button>
            ) : null}
            {showButton ? (
              <Button
                variant="primary"
                className="empty-state__button"
                onClick={onButtonClick}
              >
                {buttonIcon ? (
                  <i className={`fas ${buttonIcon}`} aria-hidden />
                ) : null}
                <span>{buttonText}</span>
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EmptyState;
